
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/communities/[slug]",
      function () {
        return require("private-next-pages/communities/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/communities/[slug]"])
      });
    }
  